export default __webpack_public_path__ + "static/media/infobox-img.1289eb18.svg";